var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.address1)?_c('div',[_vm._v(" "+_vm._s(_vm.item.address1)+" "),_c('br'),(_vm.item.address2)?_c('span',[_vm._v(_vm._s(_vm.item.address2)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.item.state + ", " + _vm.item.zip + ", " + _vm.item.city)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }